var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotingBox',_vm._b({staticClass:"reservatable-frame"},'FlotingBox',_vm.$attrs,false),[_c('div',{staticClass:"content",on:{"click":_vm.onClick}},[_c('small',[_vm._v(_vm._s(_vm._f("time")(_vm.frame.start))+" ("+_vm._s(_vm.frame.minutes)+"分)")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }